import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=106796af&"
import script from "./Text.vue?vue&type=script&lang=js&"
export * from "./Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('106796af')) {
      api.createRecord('106796af', component.options)
    } else {
      api.reload('106796af', component.options)
    }
    module.hot.accept("./Text.vue?vue&type=template&id=106796af&", function () {
      api.rerender('106796af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/utils/Badge/Text.vue"
export default component.exports